import { axiosPrivate } from 'shared/api';
import { ICostElement } from 'features/cost-analysis/costs/types';
import { BaseService } from 'shared/services/BaseService';

class CostElementService extends BaseService<ICostElement> {
  constructor() {
    super('cost-elements');
  }

  getLayerOptions = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/layer_model_options/`);
    return res.data;
  };

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const costElementService = new CostElementService();
